import type { Course } from '@/mocks/courses';

export interface CourseDbRow {
  id: string;
  title: string;
  instructor: string | null;
  category: string | null;
  level: string | null;
  price: number | null;
  duration_hours: number | null;
  lessons_count: number | null;
  language: string | null;
  description: string | null;
  objectives: string | null;
  created_at: string | null;
}

const fallbackCover =
  'https://readdy.ai/api/search-image?query=Modern%20online%20learning%20platform%20interface%20on%20a%20laptop%2C%20digital%20education%20environment%2C%20clean%20minimal%20design%2C%20warm%20lighting%2C%20professional%20editorial%20photography%2C%20high%20detail&width=800&height=500&seq=course-fallback-01&orientation=landscape';

export function mapDbCourse(row: CourseDbRow): Course {
  return {
    id: row.id,
    title: row.title,
    instructor: row.instructor || 'Instructeur',
    category: row.category || 'Développement Web',
    level: row.level || 'Débutant',
    price: row.price !== null && row.price !== undefined ? Number(row.price) : null,
    durationHours: row.duration_hours !== null ? Number(row.duration_hours) : null,
    lessonsCount: row.lessons_count !== null ? Number(row.lessons_count) : null,
    language: row.language || 'Français',
    description: row.description || '',
    objectives: row.objectives || '',
    cover: fallbackCover,
    postedAt: row.created_at ? row.created_at.slice(0, 10) : '',
  };
}

export function formatPrice(price: number | null): string {
  if (price === null || price === undefined || price === 0) return 'Gratuit';
  return `${price.toLocaleString('fr-FR')} FCFA`;
}